import {inject, Injectable} from '@angular/core';
import {Actions, createEffect, ofType, OnInitEffects} from '@ngrx/effects';
import {map, of, switchMap} from 'rxjs';
import {catchError, tap} from 'rxjs/operators';
import {OrganizationActions} from './organization.actions';
import {OrganizationService} from './organization.service';
import {withLatestFromSelectors} from '@store/common/effects.helpers';
import {OrganizationSelectors} from '@store/store.selectors';
import {MetadataService} from '@store/organization/metadata.service';

@Injectable({providedIn: 'root'})
export class OrganizationEffects implements OnInitEffects {

  private readonly actions: Actions = inject(Actions);
  private readonly service: OrganizationService = inject(OrganizationService);
  private readonly metaService: MetadataService = inject(MetadataService);

  ngrxOnInitEffects() {
    return OrganizationActions.initializeApp();
  }

  loadOrganization = createEffect(() =>
    this.actions.pipe(
      ofType(OrganizationActions.initializeApp),
      switchMap(() => this.service.loadAuthOrganization().pipe(
        map(response => OrganizationActions.loadAuthOrganizationSuccess(response)),
        catchError((error: unknown) => of(OrganizationActions.loadAuthOrganizationFailure(error)))
      ))
    )
  );

  loadMetaData = createEffect(() =>
    this.actions.pipe(
      ofType(OrganizationActions.loadAuthOrganizationSuccess),
      withLatestFromSelectors(OrganizationSelectors.Auth.organization),
      tap(([_, organization]) => this.metaService.loadMetadata(organization))
    ), {dispatch: false}
  );
}
